import colorsOptions from '../../fundamentals/colors-styles/constants'

const listItemStateVariantOptions = {
  ACTIVE: 'active',
  SELECTED: 'selected',
  INACTIVE: 'inactive',
  ERROR: 'error',
  'READ-ONLY': 'read-only',
  DEFAULT: 'default',
  HOVER: 'hover',
  DISABLED: 'disabled',
  HIGHLIGHTED: 'highlighted',
  'NON-HIGHLIGHTED': 'non-highlighted'
}

const listItemStateStyleVariantOptions = {
  [listItemStateVariantOptions.DEFAULT]: {
    backgroundColor: colorsOptions.greys.white,
    color: colorsOptions.greys['grey-100'],
    secondaryColor: colorsOptions.greys['grey-70'],
    border: `1px solid ${colorsOptions.greys['grey-20']}`,
    iconsColor: colorsOptions.greys['grey-100']
  },
  [listItemStateVariantOptions.ACTIVE]: {
    backgroundColor: colorsOptions.greys.white,
    color: colorsOptions.greys['grey-100'],
    border: `1px solid ${colorsOptions.greys['grey-20']}`,
    iconsColor: colorsOptions.greys['grey-100']
  },
  [listItemStateVariantOptions.SELECTED]: {
    backgroundColor: colorsOptions.greys['grey-05'],
    color: colorsOptions.greys['grey-100'],
    border: `1px solid ${colorsOptions.greys['grey-20']}`,
    iconsColor: colorsOptions.greys['grey-70']
  },
  [listItemStateVariantOptions.INACTIVE]: {
    backgroundColor: colorsOptions.greys.white,
    color: colorsOptions.greys['grey-40'],
    border: `1px solid ${colorsOptions.greys['grey-20']}`,
    iconsColor: colorsOptions.greys['grey-40'],
    pointerEvents: 'none'
  },
  [listItemStateVariantOptions.ERROR]: {
    backgroundColor: colorsOptions.greys.white,
    color: colorsOptions.greys['grey-100'],
    border: `2px solid ${colorsOptions.semantics.danger['error-50']}`,
    iconColor: colorsOptions.greys['grey-100']
  },
  [listItemStateVariantOptions['READ-ONLY']]: {
    backgroundColor: colorsOptions.greys.white,
    color: colorsOptions.greys['grey-70'],
    border: `1px solid ${colorsOptions.greys['grey-20']}`,
    iconColor: colorsOptions.greys['grey-70']
  },
  [listItemStateVariantOptions.HOVER]: {
    backgroundColor: colorsOptions.greys['grey-05'],
    color: colorsOptions.greys['grey-100'],
    border: `1px solid ${colorsOptions.greys['grey-20']}`,
    iconsColor: colorsOptions.greys['grey-70']
  },
  // Highlighted / non-highlighted are a pair: one item stands out (white card
  // lifted by the drop shadow) while the others sink into a dimmed background.
  [listItemStateVariantOptions.HIGHLIGHTED]: {
    backgroundColor: colorsOptions.greys.white,
    color: colorsOptions.greys['grey-100'],
    secondaryColor: colorsOptions.greys['grey-70'],
    border: `1px solid ${colorsOptions.greys['grey-20']}`,
    iconsColor: colorsOptions.greys['grey-100'],
    boxShadow:
      '0 1px 2px 0 rgba(20, 26, 33, 0.32), 0 1px 3px 0 rgba(20, 26, 33, 0.16)'
  },
  [listItemStateVariantOptions['NON-HIGHLIGHTED']]: {
    backgroundColor: colorsOptions.greys['grey-10'],
    color: colorsOptions.greys['grey-40'],
    border: `1px solid ${colorsOptions.greys['grey-20']}`,
    iconsColor: colorsOptions.greys['grey-40']
  }
}

const listItemListViewVariantOptions = {
  SEPARATE: 'separate',
  TOGETHER: 'together'
}

const listItemsCheckVariantOptions = {
  CHECKBOX: 'checkbox',
  RADIO: 'radio'
}

export {
  listItemStateVariantOptions,
  listItemStateStyleVariantOptions,
  listItemListViewVariantOptions,
  listItemsCheckVariantOptions
}
